export const SALESHUB_CONTRACT_TYPE = {
  agriculturalRiskGuarantee: 'Agricultural Risk - Guarantee',
  agriculturalRiskPurchase: 'Agricultural Risk - Purchase',
  riskGuarantee: 'Risk - Guarantee',
  riskPurchase: 'Risk - Purchase',
  riskNetGuarantee: 'Risk - Net Guarantee',
  annualkeystrategicexhibita: 'Annual/ Key/ Strategic Exhibit A',
  fixedassets: 'Fixed Assets',
  suspenseassets: 'Suspense Assets',
  inventoryassets: 'Inventory Assets',
  multichannelstraightcommission: 'Multi-Channel Straight Commission',
  straightcommission: 'Straight Commission',
  ironplanetstraightcommission:'IronPlanet Straight Commission'

};

export class ContractType {
  public static isRiskContract(contractType: string): boolean {
    if (!contractType) {
      return false;
    } else if (contractType === SALESHUB_CONTRACT_TYPE.agriculturalRiskGuarantee || contractType === SALESHUB_CONTRACT_TYPE.agriculturalRiskPurchase ||
      contractType === SALESHUB_CONTRACT_TYPE.riskGuarantee || contractType === SALESHUB_CONTRACT_TYPE.riskPurchase ||
      contractType === SALESHUB_CONTRACT_TYPE.riskNetGuarantee) {
      return true;
    } else {
      return false;
    }
  }

  public static isAuctionEventContract(contractType: string): boolean {
    if (!contractType) {
      return false;
    } else if (contractType === SALESHUB_CONTRACT_TYPE.annualkeystrategicexhibita || contractType === SALESHUB_CONTRACT_TYPE.fixedassets ||
      contractType === SALESHUB_CONTRACT_TYPE.suspenseassets || contractType === SALESHUB_CONTRACT_TYPE.inventoryassets){
      return true;
    } else {
      return false;
    }
  }

  public static isExhibitAOrInventoryContract(contractType: string){
    if (contractType && (contractType === SALESHUB_CONTRACT_TYPE.inventoryassets || contractType === SALESHUB_CONTRACT_TYPE.annualkeystrategicexhibita)){
      return true;
    }
    return false;
  }

  public static isStraightContract(contractType: string): boolean {
    if (!contractType) {
      return false;
    } else if (contractType === SALESHUB_CONTRACT_TYPE.multichannelstraightcommission || contractType === SALESHUB_CONTRACT_TYPE.straightcommission ||
      contractType === SALESHUB_CONTRACT_TYPE.ironplanetstraightcommission) {
      return true;
    } else {
      return false;
    }
  }


}
